import curd from '../curd'
const BASE_PATH = '/rule/alarm/record'

export default curd(BASE_PATH, {

  pageRecordList: (params) => ({
    url: `${BASE_PATH}/pageList`,
    method: 'GET',
    params: params
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/AlarmRecord.js